import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import CustomButton from '../CustomButton'
import axiosInstance from '../../utils/axiosInstance'
import { toast } from 'react-toastify'
import { ParseErrors } from '../../utils/ParseErrors'
import Loader from '../Loader'

interface TDeleteAgentModel {
    ToggleDeleteModel: () => void,
    id: number
}

const DeleteAgentModel = ({ ToggleDeleteModel, id }: TDeleteAgentModel) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const deleteUser = async () => {
        setIsLoading(true)
        try {
            const res = await axiosInstance.delete(`/user/delete/${id}`)
            toast.success(res.data.message)
            setIsLoading(false)
            ToggleDeleteModel()
        } catch (error) {
            console.log(error)
            toast.error(ParseErrors(error))
            setIsLoading(false)
        }
    }

    useEffect(() => {
        const prev = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && !isLoading) ToggleDeleteModel()
        }
        window.addEventListener('keydown', onKey)
        return () => {
            document.body.style.overflow = prev
            window.removeEventListener('keydown', onKey)
        }
    }, [isLoading, ToggleDeleteModel])

    return createPortal(
        <div
            className="z-[99999] w-screen h-screen fixed inset-0 bg-[color:var(--shadow-modal-scrim)] backdrop-blur-sm flex items-center justify-center max-sm:items-start max-sm:overflow-y-auto max-sm:py-4 animate-fade-in"
            onClick={() => !isLoading && ToggleDeleteModel()}
        >
            <div
                className="bg-surface border border-edge shadow-overlay min-w-[450px] max-sm:min-w-0 max-sm:w-[calc(100vw-2rem)] max-sm:px-5 rounded-2xl px-[30px] py-[20px] animate-fade-in"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="font-heading-font text-[35px] max-sm:text-[24px] bg-gradient-heading bg-clip-text text-transparent">Are you sure you wanna delete ?</h2>

                <div className="flex items-center justify-end mt-[30px]">
                    <CustomButton disabled={isLoading} className="bg-surface-elevated border border-edge hover:border-indigo-400/40 cursor-pointer rounded-lg h-[42px] px-[35px] font-[400] !text-[16px] text-text-primary mr-[10px] max-sm:px-6 transition-all" onClick={() => ToggleDeleteModel()}>Cancel</CustomButton>
                    <CustomButton disabled={isLoading} className="bg-gradient-to-r from-red-500 to-red-600 border border-white/10 shadow-lg shadow-red-500/20 hover:shadow-glow-sm hover:-translate-y-0.5 cursor-pointer rounded-lg h-[42px] px-[35px] max-sm:px-6 font-[400] !text-[16px] text-white transition-all duration-300" onClick={deleteUser}>{isLoading ? <Loader /> : "Delete"}</CustomButton>
                </div>
            </div>
        </div>,
        document.body
    )
}

export default DeleteAgentModel
